import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LoadMoreButton } from 'components/LoadMoreButton';
import Loader from 'components/Loader';
import { useInfiniteGetVoiceReports } from 'services/voice-scan/hooks';
import useAuthStore from 'store/auth';
import StartVoiceScanButton from './StartScanButton';
import PreviousScans from './PreviousScans';
import { VoiceScanReport } from 'services/voice-scan/type';
import { PATH_ROUTES } from 'routes/path';
import ScanDetail from './ScanDetail';
import MobileScanReport from './mobile/MobileScanReport';

export default function VoiceScanPage() {
  const navigate = useNavigate();

  const profileId = useAuthStore((store) => store.currentUserProfileId);

  const [readings, setReadings] = useState<VoiceScanReport[]>([]);
  const [selectedId, setSelectedId] = useState<string>('');

  const {
    data: voiceReports,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isRefetching,
    isLoading,
    refetch,
  } = useInfiniteGetVoiceReports(profileId, 1);

  useEffect(() => {
    if (voiceReports && !voiceReports.length) {
      navigate(PATH_ROUTES.START_VOICE_SCAN);
    }

    if (voiceReports?.length) {
      setReadings(voiceReports);
      setSelectedId(voiceReports[0].session_id);
    } else {
      setReadings([]);
    }
  }, [voiceReports, profileId]);

  const scrollViewElement = (
    <div>
      {hasNextPage && !isFetchingNextPage ? (
        <LoadMoreButton onClick={() => fetchNextPage()} />
      ) : isFetchingNextPage ? (
        <Loader className='border-t h-14' loaderSize='size-6' />
      ) : null}
    </div>
  );

  if (isLoading || isRefetching) {
    return <Loader />;
  }

  const onScan = () => {
    navigate(PATH_ROUTES.START_VOICE_SCAN);
  };

  return (
    <>
      <MobileScanReport
        readings={readings}
        setReadings={setReadings}
        onScan={onScan}
        refetchScanReports={refetch}
        scrollViewElement={scrollViewElement}
      />

      <div className='hidden grid-cols-9 gap-4 p-6 lg:gap-8 sm:grid'>
        <div className='col-span-3 space-y-4 xl:col-span-2'>
          <StartVoiceScanButton onScan={onScan} />

          <div className='space-y-3' id='previous-scans'>
            <PreviousScans
              readings={readings}
              setReadings={setReadings}
              selectedReadingId={selectedId}
              setSelectedReadingId={setSelectedId}
              scrollViewElement={scrollViewElement}
            />
          </div>
        </div>

        <div className='h-full col-span-6 xl:col-span-7'>
          <ScanDetail
            className='h-[calc(100vh-17rem)] lg:h-[calc(100vh-15.5rem)]'
            readingId={selectedId}
            refetchScanReports={refetch}
          />
        </div>
      </div>
    </>
  );
}
